import { createUseStyles } from 'react-jss';
import { SuggestionMenuPositions, HorizontalPositions } from '../types/index.js';
import { scrollbar } from '../../../../foundation/styleHelpers/scrollbar/scrollbar/index.js';
import { States } from '../../../../foundation/states/states/index.js';
import { Spacings } from '../../../../foundation/spacings/spacings/index.js';
import { ControlBorderColors } from '../../../../foundation/colors/controlBorderColors/controlBorderColors/index.js';
import { BackgroundColors } from '../../../../foundation/colors/backgroundColors/backgroundColors/index.js';
import { BreakPointsMedia } from '../../../../foundation/responsive/responsive/index.js';
import { isRightToLeft, isLeftToRight } from '../../../../foundation/styleHelpers/rtl/rtl/index.js';

const calculatePosition = ({ contextPosition, alignment, menuWidth }) => (alignment === HorizontalPositions.Center
    ? contextPosition?.x
    : alignment === HorizontalPositions.Right
        ? Number(contextPosition?.z) - Number(contextPosition?.width)
        : Number(contextPosition?.z) - Number(menuWidth));
const useStyles = createUseStyles({
    root: {
        position: 'fixed',
        backgroundColor: BackgroundColors.base,
        border: `1px solid ${ControlBorderColors.default}`,
        overflow: 'auto',
        maxHeight: ({ isKeyboardOpen, maxSpace }) => isKeyboardOpen && (maxSpace || 200),
        padding: Spacings.s12,
        minWidth: ({ contextPosition, alignment, isForSelect, isForPicker, }) => !isForPicker && (isForSelect && alignment === HorizontalPositions.Center) && contextPosition?.width,
        width: ({ contextPosition, alignment, isForSelect }) => !isForSelect && alignment === HorizontalPositions.Center && contextPosition?.width,
        zIndex: ({ zIndex }) => zIndex,
        top: ({ contextPosition, position }) => (position === SuggestionMenuPositions.Bottom ? `calc(${contextPosition?.y}px + ${Spacings.s8})`
            : `calc(${contextPosition?.y}px - ${Spacings.s8})`),
        [isLeftToRight]: {
            left: calculatePosition,
        },
        [isRightToLeft]: {
            left: (props) => !props.isForPicker && calculatePosition(props),
            right: (props) => (props.isForPicker ? calculatePosition(props) : undefined),
        },
        opacity: ({ isDisabled }) => isDisabled && States.disabled,
        pointerEvents: ({ isDisabled }) => isDisabled && 'none',
        ...scrollbar(),
        borderRadius: ({ sizes }) => sizes?.Default.value?.borderRadius,
        [BreakPointsMedia.XXL]: {
            '--tabs-height': ({ sizes }) => sizes?.XXL.value?.borderRadius && `${sizes?.XXL.value?.borderRadius}px`,
        },
        [BreakPointsMedia.XL]: {
            '--tabs-height': ({ sizes }) => sizes?.XL.value?.borderRadius && `${sizes?.XL.value?.borderRadius}px`,
        },
        [BreakPointsMedia.LG]: {
            '--tabs-height': ({ sizes }) => sizes?.LG.value?.borderRadius && `${sizes?.LG.value?.borderRadius}px`,
        },
        [BreakPointsMedia.MD]: {
            '--tabs-height': ({ sizes }) => sizes?.MD.value?.borderRadius && `${sizes?.MD.value?.borderRadius}px`,
        },
        [BreakPointsMedia.SM]: {
            '--tabs-height': ({ sizes }) => sizes?.SM.value?.borderRadius && `${sizes?.SM.value?.borderRadius}px`,
        },
        [BreakPointsMedia.XS]: {
            '--tabs-height': ({ sizes }) => sizes?.XS.value?.borderRadius && `${sizes?.XS.value?.borderRadius}px`,
        },
        [BreakPointsMedia.XXS]: {
            '--tabs-height': ({ sizes }) => sizes?.XXS.value?.height && `${sizes?.XXS.value?.height}px`,
        },
    },
}, {
    name: 'suggestion-menu',
});

export { useStyles };
